export * from './i18next';
export * from './react';
export * from './resources';
export * from './utils';
import completenesses from './i18n-completenesses.json';

export const i18nCompletenesses = completenesses;
